module.exports = __webpack_public_path__ + "img/73972fa.png";